import { render } from "./ReturnQueues.vue?vue&type=template&id=27202eee"
import script from "./ReturnQueues.vue?vue&type=script&lang=js"
export * from "./ReturnQueues.vue?vue&type=script&lang=js"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__